import React, {Component} from 'react';
import Modal from 'react-modal';
import loadingGIF from '../../assets/loading.gif';
import classes from './LoadingModal.css';
import {connect} from 'react-redux';

Modal.defaultStyles.overlay.backgroundColor = 'rgba(55, 179, 74, 0.8)';

export class LoadingModal extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.isLoading}
            >
                <div className={classes.LoadingModalContent}>
                    <img src={loadingGIF} alt="Loading"></img>
                    <div className={classes.loadiingMessage}>Please Wait ...</div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.globalState.isLoading
    }
};

export default connect(mapStateToProps)(LoadingModal);



// WEBPACK FOOTER //
// ./src/containers/LoadingModal/LoadingModal.js